import { Grid2 } from "@mui/material";
import React from "react";
import FormDateField from "../../../../component/form/FormDateField";
import FormDropDown from "../../../../component/form/FormDropDown";
import FormTelInput from "../../../../component/form/FormTelInput";
import FormTextField from "../../../../component/form/FormTextField";
import ImageUpload from "../components/UploadPhoto";
import ManageCities from "../../../form/steps/personal-details/ManageCities";

export default function PersonalDetails({
  control,
  watch,
  setError,
  clearErrors,
}) {
  return (
    <>
      <Grid2 size={{ xs: 12 }}>
        <ImageUpload
          control={control}
          name="image"
          watch={watch}
          required={true}
          setError={setError}
          clearErrors={clearErrors}
        />
      </Grid2>
      <Grid2 size={{ xs: 12, lg: 6 }}>
        <FormTextField
          placeholder="Name"
          label="Name"
          fieldname="name"
          control={control}
          required
          onlyText
        />
      </Grid2>

      <Grid2 size={{ xs: 12, lg: 6 }}>
        <FormDropDown
          label="Gender"
          fieldname="gender"
          control={control}
          required
          dropdownValues={[
            { label: "Male", value: "m" },
            { label: "Female", value: "f" },
          ]}
        />
      </Grid2>

      <Grid2 size={{ xs: 12, lg: 6 }}>
        <FormDateField
          label="Date of birth"
          fieldname="dateOfBirth"
          control={control}
          required
        />
      </Grid2>
      <Grid2 size={{ xs: 12, lg: 6 }}>
        <FormTelInput
          label="Phone no"
          fieldname="phoneNumber"
          required
          control={control}
        />
      </Grid2>
      <Grid2 size={{ xs: 12, lg: 6 }}>
        <FormTextField
          placeholder="Email address"
          label="Email"
          fieldname="email"
          control={control}
          required
          rules={{
            pattern: {
              value: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i,
              message: "Invalid email",
            },
          }}
        />
      </Grid2>
      <ManageCities control={control} watch={watch} />
      <Grid2 size={{ xs: 12, lg: 6 }}>
        <FormTextField
          placeholder="Address"
          label="Address"
          fieldname="address1"
          control={control}
          required
        />
      </Grid2>
    </>
  );
}
